import { render } from "./Economy.vue?vue&type=template&id=100fd732&scoped=true&ts=true"
import script from "./Economy.ts?vue&type=script&lang=ts"
export * from "./Economy.ts?vue&type=script&lang=ts"

import "./Economy.scss?vue&type=style&index=0&id=100fd732&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-100fd732"]])

export default __exports__